import { useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { getNotificationsTourDemoItems } from '../tour/get-notifications-tour-demo-items';
import { NotificationFeedFilter } from './list/notification-feed-filter';
import { NotificationFeedList } from './list/NotificationFeedList';

const noop = () => undefined;

/**
 * Presentational feed used while the notifications tour is active.
 * Bypasses Knock so the tour always shows sample rows with no side effects.
 */
export function NotificationsFeedTourDemo() {
  const { formatMessage } = useIntl();
  const items = useMemo(() => getNotificationsTourDemoItems(formatMessage), [formatMessage]);
  const [filter, setFilter] = useState<NotificationFeedFilter>('all');

  return (
    <NotificationFeedList
      items={items}
      unreadCount={0}
      filter={filter}
      onFilterChange={setFilter}
      onItemClick={noop}
      onArchive={noop}
      onButtonClick={noop}
      onMarkAllAsRead={noop}
      hasMore={false}
      isLoading={false}
      isLoadingMore={false}
      onLoadMore={noop}
    />
  );
}
